// src/components/AdminDashboard.js

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth"; //custom hook to get current user and check admin
import ManageProducts from "./admin/ManageProducts";
import ManageUsers from "./admin/ManageUsers";
import ViewOrders from "./admin/ViewOrders";

const AdminDashboard = () => {
  const { user, isAdmin } = useAuth();

  if (!user) {
    //Redirect to login page or show a loading spinner
    return <Navigate to="/login" />;
  }

  if (!isAdmin) {
    //Redirect non-admin users to a different page
    return <Navigate to="/" />;
  }

  return (
    <div>
      <h2>Admin Dashboard</h2>
      <div>
        <ManageProducts />
        <ManageUsers />
        <ViewOrders />
      </div>
    </div>
  );
};

export default AdminDashboard;
